import { render } from "./orderStatus.vue?vue&type=template&id=59132144&ts=true"
import script from "./orderStatus.ts?vue&type=script&lang=ts"
export * from "./orderStatus.ts?vue&type=script&lang=ts"

import "./orderStatus.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__